var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.153,
    height: 26,
    viewBox: "0 0 30.153 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clapping",
    transform: "translate(0 -0.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15403",
    "data-name": "Path 15403",
    d: "M89.753,224.257l3.016,8.289a.52.52,0,0,1-.312.667l-2.437.884a1.04,1.04,0,0,1-1.333-.624l-2.659-7.307a1.04,1.04,0,0,1,.624-1.333l2.437-.887A.52.52,0,0,1,89.753,224.257Zm0,0",
    transform: "translate(-80.378 -208.931)",
    fill: "#0082d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15404",
    "data-name": "Path 15404",
    d: "M138.432,65.724a2.6,2.6,0,0,1-.246,3.666l-1.816,1.585,7.492-2.727a2.12,2.12,0,0,1,2.7,1.112,2.069,2.069,0,0,1,.135,1.168l.26-.094a2.065,2.065,0,0,1,2.014,3.545,2.075,2.075,0,0,1,.772,1.077,2.12,2.12,0,0,1-1.356,2.59l-1.157.42a2.08,2.08,0,0,1-.708,3.571l-11.46,4.171c-1.213.441-3.628-.357-3.977-1.315L128.075,76.2a3.07,3.07,0,0,1,.423-2.136l.037-.079c.008-.016.016-.032.025-.047l1.836-3.074a2.565,2.565,0,0,1,.652-.85l5.191-4.444a1.578,1.578,0,0,1,.487-.29A1.555,1.555,0,0,1,138.432,65.724Zm0,0",
    transform: "translate(-119.676 -60.522)",
    fill: "#fec000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15405",
    "data-name": "Path 15405",
    d: "M327.257,259.382a.52.52,0,0,0,.667.312l3.9-1.419a.52.52,0,0,0-.356-.977l-3.9,1.42A.52.52,0,0,0,327.257,259.382Zm0,0",
    transform: "translate(-305.958 -240.113)",
    fill: "#d9a600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15406",
    "data-name": "Path 15406",
    d: "M310.876,199.052a.52.52,0,0,0,.666.312l6.826-2.484a.52.52,0,0,0-.356-.978l-6.826,2.484A.52.52,0,0,0,310.876,199.052Zm0,0",
    transform: "translate(-290.641 -182.709)",
    fill: "#d9a600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15407",
    "data-name": "Path 15407",
    d: "M294.5,159.181a.52.52,0,0,0,.666.312l5.85-2.131a.52.52,0,0,0-.356-.977l-5.852,2.132A.52.52,0,0,0,294.5,159.181Zm0,0",
    transform: "translate(-275.327 -145.763)",
    fill: "#d9a600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15408",
    "data-name": "Path 15408",
    d: "M210.651,173a.521.521,0,0,0,.389-.086,5.643,5.643,0,0,0,2.382-4.8.52.52,0,0,0-1.04,0,4.644,4.644,0,0,1-1.939,3.952.52.52,0,0,0,.208.936Zm0,0",
    transform: "translate(-196.56 -156.266)",
    fill: "#d9a600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13612",
    "data-name": "Group 13612",
    transform: "translate(6.76 0.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15409",
    "data-name": "Path 15409",
    d: "M232.52,3.061a.52.52,0,0,1-.52-.52V.981a.52.52,0,0,1,1.04,0v1.56A.52.52,0,0,1,232.52,3.061Zm0,0",
    transform: "translate(-223.681 -0.461)",
    fill: "#aeadb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15410",
    "data-name": "Path 15410",
    d: "M284.528,14.093a.52.52,0,0,1-.45-.78l.78-1.352a.52.52,0,0,1,.9.52l-.78,1.352A.52.52,0,0,1,284.528,14.093Zm0,0",
    transform: "translate(-272.309 -10.974)",
    fill: "#aeadb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15411",
    "data-name": "Path 15411",
    d: "M169.316,14.093a.52.52,0,0,1-.451-.26l-.78-1.352a.52.52,0,0,1,.9-.52l.78,1.352a.52.52,0,0,1-.45.78Zm0,0",
    transform: "translate(-163.856 -10.974)",
    fill: "#aeadb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15412",
    "data-name": "Path 15412",
    d: "M121.913,50.3a.516.516,0,0,1-.26-.07l-1.352-.78a.52.52,0,0,1,.52-.9l1.352.78a.52.52,0,0,1-.26.97Zm0,0",
    transform: "translate(-119.001 -45.364)",
    fill: "#aeadb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15413",
    "data-name": "Path 15413",
    d: "M106.08,105.5h-1.56a.52.52,0,1,1,0-1.04h1.56a.52.52,0,1,1,0,1.04Zm0,0",
    transform: "translate(-104 -97.701)",
    fill: "#aeadb3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15414",
    "data-name": "Path 15414",
    d: "M4.153,217.317v8.821a.52.52,0,0,1-.52.52H1.04A1.04,1.04,0,0,1,0,225.618v-7.781a1.04,1.04,0,0,1,1.04-1.04H3.633A.52.52,0,0,1,4.153,217.317Zm0,0",
    transform: "translate(0 -202.275)",
    fill: "#009ae5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15415",
    "data-name": "Path 15415",
    d: "M61.213,113.457a2.6,2.6,0,0,1-1.486,3.36l-2.248.868h7.974a2.12,2.12,0,0,1,2.16,1.97,2.067,2.067,0,0,1-.273,1.144h.274a2.066,2.066,0,0,1,.68,4.02,2.079,2.079,0,0,1,.356,1.277,2.119,2.119,0,0,1-2.159,1.969H65.264a2.08,2.08,0,0,1-1.886,3.114h-12.2c-1.291,0-3.288-1.577-3.288-2.6v-8.822a3.059,3.059,0,0,1,1.129-1.863l.061-.061a.448.448,0,0,1,.04-.036l2.776-2.261a2.575,2.575,0,0,1,.9-.575l6.4-2.4a1.582,1.582,0,0,1,.557-.106A1.556,1.556,0,0,1,61.213,113.457Zm0,0",
    transform: "translate(-44.782 -104.72)",
    fill: "#ffe670"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15416",
    "data-name": "Path 15416",
    d: "M215.551,337.067a.52.52,0,0,0,.52.52h4.152a.52.52,0,1,0,0-1.04h-4.152A.52.52,0,0,0,215.551,337.067Zm0,0",
    transform: "translate(-201.541 -314.242)",
    fill: "#ebb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15417",
    "data-name": "Path 15417",
    d: "M215.551,289.172a.52.52,0,0,0,.52.52h7.265a.52.52,0,1,0,0-1.04h-7.265A.52.52,0,0,0,215.551,289.172Zm0,0",
    transform: "translate(-201.541 -269.46)",
    fill: "#ebb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15418",
    "data-name": "Path 15418",
    d: "M215.551,241.27a.52.52,0,0,0,.52.52H222.3a.52.52,0,0,0,0-1.04h-6.227A.52.52,0,0,0,215.551,241.27Zm0,0",
    transform: "translate(-201.541 -224.671)",
    fill: "#ebb300"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClapping);
export default __webpack_public_path__ + "static/media/clapping.6c9af53a59167dd34e35c6e4342c787a.svg";
export { ForwardRef as ReactComponent };